import { c as _c } from "react/compiler-runtime";
export function PayPalIcon(t0) {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    bgColor: t2,
    decorative
  } = t1;
  const bgColor = t2 === undefined ? "#fff" : t2;
  const t3 = decorative ? undefined : "img";
  const t4 = decorative ? undefined : "PayPal";
  const t5 = decorative || undefined;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== bgColor) {
    t7 = <path fill={bgColor} d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" />;
    $[3] = bgColor;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t10;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z" />;
    t9 = <path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z" />;
    t10 = <path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z" />;
    $[5] = t10;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t11 = <svg className="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role={t3} aria-label={t4} aria-hidden={t5}>{t6}{t7}{t8}{t9}{t10}</svg>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}